import materialTableList from './src/materialVirtualList.vue'

export default materialTableList
